export type Bbox = [west: number, south: number, east: number, north: number];

export function normalizeLongitude(longitude: number): number {
  if (longitude >= -180 && longitude <= 180) return longitude;
  const normalized = ((((longitude + 180) % 360) + 360) % 360) - 180;
  return normalized === -180 && longitude > 0 ? 180 : normalized;
}

export function longitudeSpan(west: number, east: number): number {
  const span = east - west;
  if (span >= 360) return 360;
  return ((span % 360) + 360) % 360;
}

export function normalizeBbox([west, south, east, north]: Bbox): Bbox {
  const minLat = Math.max(-90, Math.min(90, south));
  const maxLat = Math.max(-90, Math.min(90, north));
  if (longitudeSpan(west, east) === 360) return [-180, minLat, 180, maxLat];
  return [normalizeLongitude(west), minLat, normalizeLongitude(east), maxLat];
}

export function bboxCenter(bbox: Bbox): { longitude: number; latitude: number } {
  const [west, south, east, north] = normalizeBbox(bbox);
  return {
    longitude: normalizeLongitude(west + longitudeSpan(west, east) / 2),
    latitude: (south + north) / 2,
  };
}

export function longitudeDistance(a: number, b: number): number {
  return Math.abs(normalizeLongitude(a - b));
}
